import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import MethodDetails from '../MethodDetails/MethodDetails'
import './PaymentFormBox.css'

const PaymentFormBox = ({children, methodData}) => {
    const [isUpdating, setisUpdating] = useState(false);
    useEffect(() => {
        !(methodData.EFTAccountName && methodData.EFTAccountNumber && methodData.payID) ? setisUpdating(true) : setisUpdating(false) 
    }, [methodData])
    return (
        <div className="payment-data-manage">
            {isUpdating ?
            <div className="data-input">
                {children}
                <button className='cancle-updating' onClick={() => setisUpdating(false)}>Cancle Updating</button>
            </div>
            :
            <MethodDetails methodData={methodData} setisUpdating={setisUpdating} />
            }
        </div>
    )
}

export default PaymentFormBox
